export default __webpack_public_path__ + "media/images/Masto-H2-Ganesh-2e02f70f5ac8ee4c33afccaaf619ac3d.png";